/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Types from '../types/Types';
import Meals from '../meals/Meals';
import goBack from '../../assets/images/left-arrow2.svg';
import FacebookIcon from '../../assets/images/facebookIcon.svg';
import InstagramIcon from '../../assets/images/instagram-svgrepo-com.svg';
import WazeIcon from '../../assets/images/brand-waze.svg';
import GlobeIcon from '../../assets/images/globe.svg';
import './Home.scss';
import "../../App.scss"

function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [fadeClass, setFadeClass] = useState('fade-in');


  useEffect(() => {
    if (isFirstLoad && location.pathname !== '/') {
      navigate('/');
      setIsFirstLoad(false);
    } else if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [isFirstLoad, location.pathname, navigate]);

useEffect(() => {
  if (location.pathname === '/') {
    setFadeClass('fade-in');
    const timeout = setTimeout(() => setFadeClass(''), 600);
    return () => clearTimeout(timeout);
  }
}, [location.pathname]);


  const navigateBack = () => {
    navigate(-1);
  };

  const firstChildStyles = {
    backgroundColor: 'white',
    borderRadius: '45px',
  };

  return (
    <div className='App'>
<div className={`home-page ${location.pathname === '/meals' ? 'no-background' : ''}`}>
        <button className="goBack-wrapper" type="button" onClick={navigateBack}>
          <img
            className={location.pathname === '/' ? 'hide' : 'go-Back'}
            src={goBack}
            alt="go-back"
          />
        </button>

        {/* 👇 Show developer-info ONLY if not on /meals */}
        {location.pathname !== '/meals' && (
          <div className="developer-information" style={firstChildStyles}>
            <h1>התפריט שלנו</h1>
            <span className="location">&nbsp; ראמה, ישראל</span>
            <span className="phone-number">&nbsp; 054-8993333</span>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=100040296173784"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="FacebookIcon" src={FacebookIcon} alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/deluxe._.patisserie/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="InstagramIcon" src={InstagramIcon} alt="Instagram" />
              </a>
              <a
                href="https://ul.waze.com/ul?venue_id=23200073.231869662.2068717&overview=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="WazeIcon" src={WazeIcon} alt="Waze" />
              </a>
              <a
                href="/website"
                target="_blank"
                rel="noopener noreferrer"
                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
              >
                <img className="GlobeIcon" src={GlobeIcon} alt="Globe" />
              </a>
            </div>
            <hr className="custom-line" />
          </div>
        )}

        {/* Home routes only */}
<div className={`page-transition ${location.pathname === '/' ? 'fade-in' : ''}`}>
  <Routes>
    <Route path="/" element={<Types />} />
    <Route path="/meals" element={<Meals />} />
  </Routes>
</div>
      </div>
    </div>
  );
}

export default Home;
